import { useEffect, useState } from "react";
import "./styles.css";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import { useAmplitude } from "../../../context/AmplitudeContext";
import { useUID } from "../../../context/UIDContext";
import { useTranslation } from "react-i18next";

export const ProductInfoPage = ({
  onBackClick,
  productData,
  selectedFavorites,
  onFavoriteClick,
}) => {
  const {t} = useTranslation("recommendation")
  const trackEvent = useAmplitude();
  const { uid } = useUID();
  const [step, setStep] = useState(0);
  const existsByKey = (list, value) => {
    return list.some((item) => item["value"] === value);
  };

  useEffect(() => {
    trackEvent("webapp_user_visited_products_info_page", uid);
  }, [uid, trackEvent]);

  const productIsFavorite = existsByKey(
    selectedFavorites,
    productData[step].value,
  );

  return (
    <div className="product-info-page">
      <img
        src={productData[step].image}
        alt="product"
        className="product-info-image"
      />
      <div className="product-info-image-background" />
      <div className="product-info-page-nav">
        <div
          className="product-info-back-button-wrapper"
          onClick={() => {
            trackEvent(
              "webapp_user_back_button_products_info_page",
              uid,
              "",
              "",
              productData[step].title,
            );
            onBackClick();
          }}
        >
          <IoChevronBackOutline className="product-info-back-icon" />
          <p className="product-info-back-text">{t("productInfoPage.back")}</p>
        </div>
      </div>
      <div className="product-info-text-container">
        <h4 className="product-info-step-text">{productData[step].step}</h4>
        <h4 className="product-info-title-text">{productData[step].title}</h4>
        <p className="product-info-description-text">
          {productData[step].description}
        </p>
      </div>
      <div className="product-info-buttons-container">
        <div
          onClick={() => setStep((prev) => (prev - 1 < 0 ? prev : prev - 1))}
          className={`product-info-direction-button`}
        >
          <IoChevronBackOutline />
        </div>
        <div
          onClick={() => onFavoriteClick(productData[step])}
          className="product-info-favorite-button"
        >
          {productIsFavorite ? (
            <IoMdHeart className="product-info-favorite-icon" />
          ) : (
            <IoMdHeartEmpty className="product-info-favorite-icon" />
          )}
          <p>{t("productInfoPage.favorites")}</p>
        </div>
        <div
          onClick={() =>
            setStep((prev) =>
              prev + 1 >= productData.length ? prev : prev + 1,
            )
          }
          className={`product-info-direction-button`}
        >
          <IoChevronForwardOutline />
        </div>
      </div>
    </div>
  );
};
